import { getApiErrorMessage, getErrorStatusCode } from "shared/utils";
import type { ApiError } from "shared/utils";

export type LinkError = ApiError;
export { getErrorStatusCode };

const FALLBACK_MESSAGES: Record<number, string> = {
  400: "Invalid request. Please try again.",
  401: "Authorization required. Please sign in again.",
  404: "This link is no longer valid.",
  409: "Telegram link state conflict. Please refresh and try again.",
  503: "Service is temporarily unavailable. Please try again later.",
};

const DEFAULT_MESSAGE = "Something went wrong. Please try again.";

export const getTelegramLinkError = (error: LinkError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, DEFAULT_MESSAGE);
